<!-- Source列表展示 -->
<template>
  <div class="LeftSourceList">
    <div class="contentleftBottom">
      <div class="FileSourceTop" ref="LiveSourceListTop" @click="HideSourceAction">
        <!-- 头部操作 -->
        <div class="searchTitle">
          <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.search') }}</div>
            </div>
            <i
            class="iconfont icon-search pointer"
            @click="searchShow"
            ></i>
          </el-tooltip>
          <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.addSource') }}</div>
            </div>
            <i
            :disabled="CloneDisabled.VideoAdd||CloneDisabled.disableButton"
            class="iconfont icon-add pointer"
            @click.stop="SettingSwitch('AddSource')"
            ></i>
          </el-tooltip>
          <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.filters') }}</div>
            </div>
            <i
            class="iconfont icon-zimupaixu pointer"
            @click.stop="SettingSwitch('SortSource')"
           ></i>
          </el-tooltip>
        </div>
        <div class="addClassWrap" v-if="SourceSwitch.SourceClassSwitch" @click.stop="">
          <div class="SourceClass" v-for="(item,index) in SourceClass" :key="index" @click="AddSourceClass(item.type)">
            {{$t(item.name)}}
          </div>
        </div>
        <div class="SortListWrap" v-if="SourceSwitch.SortSwitch" @click.stop="">
          <div class="SourceClass" v-for="(item,index) in SortList" :key="index" @click="SwitchingSequence(item.type)">
            <i :class="['iconfont',item.icon]"></i>
             {{$t(item.name)}}
          </div>
        </div>
        <!-- 搜索 -->
        <div
          class="searchInput"
          v-if="sourceInput">
          <el-input
            ref="ResourceSearch"
            v-model="sourceCondition"
            :placeholder="$t('lang.searchTText')"
            @keyup.enter.native="searchChange"></el-input>
          <i
            class="iconfont icon-search pointer"
            @click="searchChange"></i>
        </div>
      </div>
      <div class="AllSourceWrap" id="AllSourceWrap" v-loading='sourceDataLoading'>
        <el-collapse v-model="activeName" @change="handleChange">
          <el-collapse-item :name="SourceItem.type" v-for="SourceItem in SourceClassifyConfig" :key="SourceItem.type">
            <template slot="title">
            <i v-if="!SourceItem.switch" class="el-icon-caret-right"></i> <i v-else class="el-icon-caret-bottom"></i>{{$t(SourceItem.name)}}{{` (${InquireSourceParam[SourceItem.type] ? InquireSourceParam[SourceItem.type].total : ''})`}}
            </template>
            <source-scroll-load :key="SourceItem.type + '1'"
              :SourceType="SourceItem.type"
              :sourceData="sourceData[SourceItem.type]"
              :PitchSource="PitchSource" :SourceThumbnail="SourceThumbnail"
              @ScrollUpdateSource="ScrollUpdateSource"
              @getCheck="getCheck"
              @deleteSource="DeleteSource"
              @editSource="EditSource"
              @reGetSourceList='reGetSourceList'
              ></source-scroll-load>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="TVUCommon">
        <div class="anywhereSource" v-if="addAnywhereInfo.show" >
            <tvu-add-anywhere-source v-if="addAnywhereInfo.show" :sourceProps="addAnywhereInfo" @callback="AnywhereCallback"></tvu-add-anywhere-source>
        </div>
        <tvu-rtmp-push v-if="addRTMPInfo.show" :rtmpProps="addRTMPInfo" @callback="RTMPCallback"></tvu-rtmp-push>
        <tvu-add-ext-source v-if="addExtInfo.show" :extProps="addExtInfo" @callback="extCallback"></tvu-add-ext-source>
        <tvu-delete-source  v-if="deleteSourceParam.show" :sourceProps="deleteSourceParam" @callback="deleteCallback"></tvu-delete-source>
        <tvu-srt-source v-if="addSrtSource.show" :srtProps="addSrtSource" @callback="extCallback"></tvu-srt-source>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { SHOWDEVICEIMG } from '@/assets/js/filters'
import { setInterval, clearInterval } from 'timers'
import toTips from '@/assets/js/toTipsObj'
import { componentsAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import Outil from '@/assets/js/utils.js'
import { SourceClassifyConfig, InquireSourceParam } from '@/assets/js/temConfig.js'
import SourceScrollLoad from './SourceScrollLoad.vue'
export default {
  props: {
  },
  components: {
    SourceScrollLoad
  },
  data () {
    return {
      // 拥有者id
      OwnerUserid: '',
      addExtInfo: {
        show: false, // 用于显示或关闭弹窗
        sourceId: '', // 用于编辑时的查询
        rid: '', // receiverId,如果传值，则将ext发送给Receiver
        userId: '',
        type: '',
        supportAudioType: 'Ext,YouTube,RTP,RTPFECPush'
      },
      deleteSourceParam: {
        show: false,
        type: '', // 删除source的类型
        origin: 6,
        rid: '', // （anywhere需要传参）
        sourceId: '', // 要删除的source的peerId
        ownerUserId: ''
      },
      addAnywhereInfo: {
        show: false, // 用于显示或关闭弹窗
        origin: 6, // 各个服务对应的key值，具体服务需要咨询gabriel
        rIds: [], // 数组或者不传
        userId: ''
      },
      addRTMPInfo: {
        show: false, // 用于显示或关闭弹窗
        sourceId: '', // 用于编辑时的查询
        origin: 6, // 各个服务对应的key值，具体服务需要咨询gabriel
        rIds: [], // 数组或者不传
        userId: '',
        type: ''
      },
      addSrtSource: {
        show: false, // 用于显示或关闭弹窗
        sourceId: '', // 用于编辑时的查询
        rid: '', // receiverId,如果传值，则将ext发送给Receiver
        userId: '',
        type: '',
        supportAudioType: 'Ext,YouTube,RTP,RTPFECPush'
      },
      // 打开live的tab
      activeName: [],
      // 新增类型列表
      SourceClass: [
        {
          name: 'lang.EXTSource',
          type: 'EXTSource'
        },
        {
          name: 'lang.AnywhereSource',
          type: 'Anywhere'
        },
        {
          name: 'lang.RTMPPush',
          type: 'RTMPPush'
        },
        {
          name: 'lang.SRT',
          type: 'SRT'
        }
      ],
      // sourec排序
      SortList: [
        {
          name: 'lang.AlphabeticalSorting',
          type: 'Alphabetical',
          icon: 'icon-zimupaixu'
        },
        {
          name: 'lang.DynamicSorting',
          type: 'Dynamic',
          icon: 'icon-zhuangtai'
        }
      ],
      SortMode: 'Alphabetical',
      // 分类列表
      SourceClassifyConfig: JSON.parse(JSON.stringify(SourceClassifyConfig)),
      // 分类参数
      InquireSourceParam: JSON.parse(JSON.stringify(InquireSourceParam)),
      // 选中source
      PitchSource: '',
      // source数据
      sourceData: {
        ext: [],
        pack: [],
        anywhere: [],
        gridsdi: [],
        gridpack: []
      },
      sourcePar: {
        // 获取源列表的参数
        rid: '',
        condition: '',
        origin: 6,
        pageNum: 1,
        pageSize: 35
      },
      SourceSwitch: {
        bookmark: true,
        filterBox: false,
        SourceClassSwitch: false, // Source添加类别选择开关
        SortSwitch: false // 排序类型选择
      },
      // 搜索开关
      sourceInput: false,
      // 搜索的内容
      sourceCondition: '',
      errorImg: `this.src="${require('@/assets/img/logo_thumbnail.png')}"`,
      // 可是范围内的source列表
      ScopeSourceList: [],
      ScopeSourceListId: [],
      // 上一次图片缩略图
      LastImagePerview: {},
      // 当前图片缩略图
      CurrentImagePerview: {},
      // 当前图片缩略图
      SourceThumbnail: {},
      // 计时器
      Interval: null,
      sourceDataLoading: false
    }
  },
  created () {
    const ProgramRMessage = Outil.getProgramReceiver()
    if (ProgramRMessage) {
      this.RId = ProgramRMessage.peerId
    }
    this.OwnerUserid = Outil.getProgramReceiver('ownerUserId')
    this.$nextTick(() => {
      this.getSourceList()
    })
  },
  mounted () {
    // this.monitorSourceScroll()
    if (this.Interval) {
      clearInterval(this.Interval)
    }
    this.activeName = ['ext']
    this.Interval = setInterval(() => {
      this.getLastandCurrent()
    }, 20000)
    document.addEventListener('click', this.clickEvent, true)
  },
  computed: {
    ...mapState({
      pageRequest: (state) => state.websocket.pageRequest,
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  methods: {
    // source一些设置开关
    SettingSwitch (type) {
      if (type == 'AddSource') {
        if (this.CloneDisabled.VideoAdd || this.CloneDisabled.disableButton) return
        this.SourceSwitch.SourceClassSwitch = !this.SourceSwitch.SourceClassSwitch
        this.SourceSwitch.SortSwitch = this.SourceSwitch.SourceClassSwitch ? false : this.SourceSwitch.SortSwitch
      } else {
        this.SourceSwitch.SortSwitch = !this.SourceSwitch.SortSwitch
        this.SourceSwitch.SourceClassSwitch = this.SourceSwitch.SortSwitch ? false : this.SourceSwitch.SortSwitch
      }
    },
    // 切换排序
    SwitchingSequence (type) {
      this.SortMode = type
      this.SourceSwitch.SortSwitch = false
      this.reGetSourceList()
    },
    // 添加ext的回调
    extCallback (data) {
      if (data.result && data.result.errorCode == '0x0') {
        this.reGetSourceList('ext')
      } else if (data.result) {
        const errorInfo = (this.$t(toTips[data.result.errorCode]) || data.result.errorInfo)
        this.$message.error(errorInfo)
      }
    },
    // 添加Anywhere回调
    AnywhereCallback (data) {
      if (data == 1) {
        this.$message.success(this.$t('lang.addSuccess'))
        this.reGetSourceList('anywhere')
      }
    },
    // 添加RTMP的回调
    RTMPCallback (data) {
      if (data.result && data.result.errorCode == '0x0') {
        this.reGetSourceList('rtmp')
      }
    },
    // source展开
    handleChange (data) {
      this.SourceClassifyConfig.forEach((item) => {
        if (this.activeName.includes(item.type)) {
          item.switch = true
        } else {
          item.switch = false
        }
      })
    },
    // 删除回调
    deleteCallback (data) {
      if (data.result && data.result.errorCode == '80802001') {
        const errorInfo = this.$t(toTips[data.result.errorCode]) || data.result.errorInfo
        this.$message(errorInfo)
        this.deleteSourceParam.show = false
      }
      if (this.deleteSourceParam.type) {
        this.reGetSourceList(this.deleteSourceParam.type)
      } else {
        this.reGetSourceList()
      }
    },
    // 删除
    DeleteSource (data) {
      if (this.CloneDisabled.LiveSource) return
      this.deleteSourceParam.rid = this.RId
      this.deleteSourceParam.sourceId = data.data.peerId
      this.deleteSourceParam.type = data.type
      this.deleteSourceParam.ownerUserId = this.OwnerUserid
      this.deleteSourceParam.show = true
    },
    // 编辑
    EditSource (data) {
      if (this.CloneDisabled.LiveSource) return
      if (data.type == 'ext' || data.type == 'RTPFECPush') {
        if (data.data.type == 'SRT') {
          this.addSrtSource.rid = this.RId
          this.addSrtSource.userId = this.OwnerUserid
          this.addSrtSource.sourceId = data.data.peerId
          this.addSrtSource.type = data.type
          this.addSrtSource.show = true
        } else {
          this.addExtInfo.rid = this.RId
          this.addExtInfo.userId = this.OwnerUserid
          this.addExtInfo.sourceId = data.data.peerId
          this.addExtInfo.type = data.type
          this.addExtInfo.show = true
          if (data.type == 'ext') {
            this.addExtInfo.sourceType = 'Ext'
          }
        }
      } else if (data.type == 'rtmp') {
        this.addRTMPInfo.rid = this.RId
        this.addRTMPInfo.userId = this.OwnerUserid
        this.addRTMPInfo.sourceId = data.data.peerId
        this.addRTMPInfo.show = true
        this.addRTMPInfo.type = data.type
      }
    },
    // 新增source
    AddSourceClass (type) {
      const OwnerUserid = this.OwnerUserid
      if (type == 'EXTSource') {
        this.addExtInfo.rid = this.RId
        this.addExtInfo.userId = OwnerUserid
        this.addExtInfo.sourceId = ''
        this.addExtInfo.show = true
        this.addExtInfo.type = type
      } else if (type == 'Anywhere') {
        this.addAnywhereInfo.rIds = [this.RId]
        this.addAnywhereInfo.userId = OwnerUserid
        this.addAnywhereInfo.show = true
      } else if (type == 'RTMPPush') {
        this.addRTMPInfo.rid = this.RId
        this.addRTMPInfo.userId = OwnerUserid
        this.addRTMPInfo.sourceId = ''
        this.addRTMPInfo.show = true
      } else if (type == 'SRT') {
        this.addSrtSource.rid = this.RId
        this.addSrtSource.userId = OwnerUserid
        this.addSrtSource.sourceId = ''
        this.addSrtSource.show = true
        this.addSrtSource.type = type
      }
      console.log(this.addSrtSource)
      this.SourceSwitch.SourceClassSwitch = false
    },
    // 搜索显示
    searchShow () {
      componentsAnalyze('sourceListSearchShow', '/ponent')
      this.sourceInput = !this.sourceInput
      this.SourceSwitch.filterBox = false
      if (!this.sourceInput) {
        this.sourceCondition = ''
        this.reGetSourceList()
      } else {
        this.$nextTick(() => {
          this.$refs.ResourceSearch.focus()
        })
      }
    },
    // 过滤显示
    filterShow () {
      componentsAnalyze('sourceListFilterShow', '/ponent')
      this.SourceSwitch.filterBox = !this.SourceSwitch.filterBox
      this.sourceInput = false
    },
    prevent (e) {
      componentsAnalyze('sourceListPrevent', '/ponent')
      e.stopPropagation()
    },
    // bookmark，filter开关
    switchShowBF () {
      componentsAnalyze('sourceListSwitchShowBF', '/ponent')
      this.SourceSwitch.bookmark = !this.SourceSwitch.bookmark
    },
    // 清空搜索条件重新查询
    reGetSourceList (type) {
      // 单个清除
      if (type) {
        this.InquireSourceParam[type].pageNum = 1
        this.getSourceList(type)
      // 全部清除
      } else {
        this.InquireSourceParam = JSON.parse(JSON.stringify(InquireSourceParam))
        this.getSourceList()
      }
    },
    // 点击source发生事情
    getCheck (data, type) {
      componentsAnalyze('sourceListClickSource', '/ponent')
      if (this.PitchSource == data.id) {
        this.PitchSource = ''
      } else {
        this.PitchSource = data.id
      }
      const objSourceR = {}
      let LiveType = type == 'rtmp' ? 'ext' : type
      LiveType = LiveType || 'Source'
      if (LiveType == 'ext') {
        objSourceR.sourceData = data
        objSourceR.type = LiveType
        this.$emit('SetPreviewVideo', data, LiveType)
        Bus.$emit('palySourceVideo', objSourceR)
      } else {
        this.axios.post(Outil.getUrl('/device/getDeviceByPeerId'), {
          peerId: data.peerId
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            const val = res.data.result
            if (val) {
              this.$set(this.sourceData[type], data.index, val)
              objSourceR.sourceData = val
              objSourceR.type = LiveType
              this.$emit('SetPreviewVideo', val, LiveType)
              Bus.$emit('palySourceVideo', objSourceR)
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
      }
    },
    // 缩略图
    thumblImg (x) {
      if (x.status == 2 && this.CurrentImagePerview[x.peerId] != undefined && this.CurrentImagePerview[x.peerId] == this.LastImagePerview[x.peerId]) return
      if (this.CurrentImagePerview[x.peerId] != undefined && this.CurrentImagePerview[x.peerId] == this.LastImagePerview[x.peerId] && x.status == 1) return
      this.LastImagePerview[x.peerId] = this.CurrentImagePerview[x.peerId]
      this.SourceThumbnail[x.peerId] = SHOWDEVICEIMG(x)
    },
    // 获取source列表
    getSourceList (type) {
      let params = {
        rid: '',
        condition: '',
        origin: 6,
        pageNum: 1,
        pageSize: 12,
        queryList: ['ext', 'pack', 'anywhere', 'gridsdi', 'gridpack', 'rtmp', 'producer'],
        relationExt: true,
        showAudioLevel: true
      }
      if (type) params = this.InquireSourceParam[type]
      if (this.sourceCondition) {
        const condition = this.sourceCondition
        this.sourceCondition = condition.replace(/(^\s*)|(\s*$)/g, '')
        params.condition = this.sourceCondition
        params.pageSize = 1000
      }
      params.userId = this.OwnerUserid
      // 排序方式
      params.sort = this.SortMode == 'Alphabetical'
      params.rid = this.RId
      params.relationExt = true
      params.showAudioLevel = true
      if (params.pageNum == 1) {
        this.sourceDataLoading = true
      }
      // 获取source 数据
      this.$getSourcePage({
        ...this.$TVU,
        params,
        success: (val) => { // 接口成功的回调，返回result
          this.sourceDataLoading = false
          for (const key in val) {
            if (!val[key].list) val[key].list = []
            if (params.pageNum == 1) {
              this.sourceData[key] = val[key].list
            } else {
              this.$set(this.sourceData, key, this.sourceData[key].concat(val[key].list))
            }
            if (this.InquireSourceParam[key]) {
              this.InquireSourceParam[key].hasNextPage = val[key].hasNextPage
              this.InquireSourceParam[key].total = val[key].total
              this.$forceUpdate()
            }
          }
          let deviceList = []
          for (const sourceKey in this.sourceData) {
            deviceList = deviceList.concat(this.sourceData[sourceKey])
          }
          deviceList.forEach((item) => {
            this.thumblImg(item)
          })
          this.getThumbnailSource()
          Bus.$emit('leftListUpdate')
          // 获取视野范围内的source
          // this.getVisualScopeSource()
          // 获取当前和上一次图片是否一样
          this.getLastandCurrent()
          this.SourceWebsocket()
        },
        error: (val) => { /// /接口失败的回调，会包含失败的状态码
          this.sourceDataLoading = false
          console.info(91, val)
        }
      })
    },
    // 滚动加载
    ScrollUpdateSource (type) {
      if (this.InquireSourceParam[type].hasNextPage) {
        this.InquireSourceParam[type].pageNum = this.InquireSourceParam[type].pageNum + 1
        this.getSourceList(type)
      }
    },
    // 搜索
    searchChange () {
      componentsAnalyze('sourceListSearchChange', '/ponent')
      this.getSourceList(null)
    },
    // 获取需要更新缩略图的source
    getThumbnailSource () {
      this.ScopeSourceList = []
      for (const sourceKey in this.sourceData) {
        if (sourceKey != 'ext') {
          this.ScopeSourceList = this.ScopeSourceList.concat(this.sourceData[sourceKey])
        }
      }
      this.ScopeSourceListId = []
      this.ScopeSourceList.forEach((item) => {
        this.ScopeSourceListId.push(item.peerId)
      })
    },
    // websocket获取source信息
    SourceWebsocket () {
      if (this.$createWebsocket.pageRequest) {
        this.$createWebsocket.pageRequest('stop', ['taskInfo_T_S']) // 停止websocket
      }
      this.pageRequest.send({
        message: {
          type: 'taskInfo',
          module: 'taskInfo_T_S',
          data: {
            peerIds: this.ScopeSourceListId.length
              ? this.ScopeSourceListId.join(',')
              : ''
          }
        },
        time: 1000,
        key: 'taskInfo_T_S',
        success: (res) => {
          if (res.result.length > 0) {
            for (const key in this.sourceData) {
              if (key != 'ext') {
                this.sourceData[key].forEach((item, index) => {
                  res.result.forEach((item1) => {
                    if (item.id == item1.id) {
                      this.thumblImg(item1)
                      this.sourceData[key].splice(index, 1, item1)
                    }
                  })
                })
              }
            }
          }
        }
      })
    },
    // 获取当前和上一次图片是否一样
    getLastandCurrent () {
      const SourceListPId = JSON.parse(JSON.stringify(this.ScopeSourceListId))
      if (SourceListPId && SourceListPId.length == 0) return
      this.axios
        .post(
          `${location.protocol}//${
          this.$store.state.common.baseUrl.blobUrl.split('/')[0]
          }/thumbnailVersion`,
          SourceListPId,
          { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
        )
        .then((res) => {
          this.LastImagePerview = this.CurrentImagePerview
          this.CurrentImagePerview = res.data
        })
    },
    // 获取可视范围内的source
    getVisualScopeSource () {
      const sourceHeight = 99
      const sourceBoxHeiht = 470
      const sourceTotal = this.sourceData.length - 1
      // 滚出高度
      const { scrollTop } = document.querySelector(
        '.contentleftBottom .SourceListWrap .sourceItem'
      )
      // 获取第一个和最后一个下标
      let sourceTopIndex,
        sourceBottomIndex
      if (scrollTop) {
        sourceTopIndex = Math.ceil(scrollTop / sourceHeight) * 3 - 3
        sourceBottomIndex =
          Math.ceil((scrollTop + sourceBoxHeiht) / sourceHeight) * 3 - 1
      } else {
        sourceTopIndex = 0
        sourceBottomIndex =
          Math.ceil((scrollTop + sourceBoxHeiht) / sourceHeight) * 3 - 1
      }
      // 超过总数取最大
      sourceBottomIndex =
        sourceBottomIndex > sourceTotal ? sourceTotal : sourceBottomIndex

      this.ScopeSourceList = []
      this.ScopeSourceListId = []
      for (let i = sourceTopIndex; i <= sourceBottomIndex; i++) {
        // 存一下下标以备后面数据多了以后做局部的更新数据
        this.ScopeSourceList.push({
          index: i,
          id: this.sourceData[i].id,
          peerId: this.sourceData[i].peerId,
          name: this.sourceData[i].name
        })
        this.ScopeSourceListId.push(this.sourceData[i].peerId)
      }
      this.SourceWebsocket()
    },
    // 监听source滚动
    monitorSourceScroll () {
      let Timeout
      $('.contentleftBottom .SourceListWrap .sourceItem').scroll(() => {
        if (Timeout) clearTimeout(Timeout)
        Timeout = setTimeout(() => {
          // this.getVisualScopeSource()
        }, 200)
      })
    },
    //  隐藏选项列表
    HideSourceAction () {
      this.SourceSwitch.SourceClassSwitch = false
      this.SourceSwitch.SortSwitch = false
    },
    // 点击组件之外地方
    clickEvent (e) {
      const event = e || window.event
      const tar = event.srcElement || event.target
      try {
        if (!this.$refs.LiveSourceListTop.contains(tar)) {
          this.SourceSwitch.SourceClassSwitch = false
          this.SourceSwitch.SortSwitch = false
        }
      } catch (error) {
      }
    },
    // 跳转到cc
    hrefCc () {
      const { protocol } = document.location
      window.open(`${protocol}//${this.ccUrl}`)
    }
  },
  beforeDestroy () {
    if (this.Interval) {
      clearInterval(this.Interval)
    }
    document.removeEventListener('click', this.clickEvent, true)
    if (this.$createWebsocket.pageRequest) {
      this.$createWebsocket.pageRequest('stop', ['taskInfo_T_S']) // 停止websocket
    }
  }
}
</script>

<style scoped lang="less">
.LeftSourceList {
  height: 100%;
  .contentleftBottom {
    width: 100%;
    height: 100%;
    position: relative;
    .FileSourceTop {
      .searchTitle {
        padding: 12px 0 10px 0;
        border-bottom: 2px solid #555;
        text-align: right;
        i {
          margin: 0 4px;
          color: #cccccc;
        }
      }
      .addClassWrap,.SortListWrap{
        background: #252525;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 20px;
        left: 100%;
        z-index: 1000;
        text-align: left;
        padding: 10px 24px;
        .SourceClass{
          width: max-content;
          padding: 12px 0px;
          font-size: 14px;
          font-weight: 600;
          color: #DBDBDB;
          line-height: 1;
          cursor: pointer;
        }
        i{
          color:#DBDBDB;
        }
      }
      .searchInput {
        position: relative;
        ::v-deep .el-input__inner {
          padding-right: 45px;
        }
        i {
          position: absolute;
          right: 12px;
          font-size: 20px;
          top: 7px;
          z-index: 1000;
        }
      }
    }
    .AllSourceWrap{
      height: calc(100% - 50px);
      overflow-y: auto;
      ::v-deep .el-collapse{
        border: none;
        .el-collapse-item__header{
          background-color: #444444;
          border: none;
          color: #dfdfdf;
          i{
            margin-right: 5px;
          }
          .el-icon-arrow-right{
            display: none;
          }
        }
        .el-collapse-item__wrap{
          background-color: #444444;
          border: none;
          .el-collapse-item__content{
            padding-bottom: 0px;
          }
        }
      }
    }
    #AllSourceWrap::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
    }
    .anywhereSource {
      position: absolute;
      top:46px;
      left: 88%;
      z-index: 1000;
    }
    .hrefCc {
      height: 30px;
      a {
        height: 100%;
        line-height: 40px;
        float: left;
        color: #33ab4f;
        cursor: pointer;
        font-size: 14px;
        padding-left: 21px;
      }
    }
    ::v-deep .TVUCommon {
      .el-dialog__wrapper {
        .el-dialog__header {
          line-height: 1;
          .el-dialog__headerbtn {
            top: 20px;
            right: 20px;
          }
        }
        .el-dialog__footer {
          .el-button {
            width: 80px;
            padding: 9px 15px;
          }
        }
      }
    }
  }
}
</style>
